import { useAppSelector } from '../store';
import { useTranslation } from './i18n';
import { isActivatingGlobalAccount } from '../utils/onboarding';

export const useProductLock = () => {
  const { t } = useTranslation();
  const selectedCompany = useAppSelector((state) => state.companyUser.companyUser?.selectedCompany);
  return {
    isLocked: isActivatingGlobalAccount(selectedCompany),
    lockedHint: t('common:productEmptyState.lockedHint'),
  };
};
